import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-md-10 d-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "Inbound Analytics")
], -1)
const _hoisted_4 = {
  id: "inboundChart",
  class: "chart"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_apexchart, {
          type: "line",
          height: "265",
          options: _ctx.inboundChart,
          series: _ctx.submissions
        }, null, 8, ["options", "series"])
      ])
    ])
  ]))
}